
import styles from './call_to_action_card.module.sass'

import BlockWrapper from './layout/block_wrapper'

import classNames from 'classnames'

import Image from './basic/image'
import Button from './basic/button'
import ScrollAnimation from './layout/scroll_animation'

function CallToAction(props) {
	const fields = props.fields

	return <BlockWrapper {...props} className={classNames(styles.call_to_action_card, styles[fields.style])} >
		<ScrollAnimation styles={styles}>
			<div className={styles.call_to_action_card_wrapper}>
				{fields.image && <Image {...fields.image} className={styles.image} />}
				<div className={styles.content_wrapper}>
					{fields.content && <div dangerouslySetInnerHTML={{__html: fields.content}} className={styles.content}></div>}
					{fields.button_clone.button.url && <Button fields={fields.button_clone} button_style='style_1' color='white' className={styles.button}>{fields.button_clone.button.title}</Button>}
				</div>
			</div>
		</ScrollAnimation>
	</BlockWrapper>

}

export default CallToAction